import {
  threadPanelLastDockedKey,
  threadPanelLayoutHintKey,
} from './thread-panel-layout-hint';
import {
  THREAD_SKELETON_SHAPE_ATTR,
  threadTranscriptShapeKey,
} from './thread-transcript-shape-hint';

/**
 * Set on <html> before first paint when the thread being loaded last
 * restored with its artifact panel docked. The loading skeleton reserves the
 * panel column from it, so a cold load (server HTML, then hydration) no
 * longer paints the chat full width and snaps it narrow once JS runs.
 */
export const THREAD_PANEL_RESERVED_ATTR = 'data-thread-panel-reserved';

/**
 * The identity the panel hints were last written under. The boot script
 * runs before any provider knows who is signed in, so it reads the hint
 * under this identity; a different signed-in user simply finds no hint.
 */
export const THREAD_PANEL_HINT_IDENTITY_KEY =
  'imai:thread-panel-docked:identity';

/** Inline <head> script: marks <html> when the hint says the panel docks. */
export function threadPanelReserveBootScript(): string {
  // The key format comes from the hint module, with placeholders the script
  // fills in, so the two can never drift apart.
  const template = threadPanelLayoutHintKey({
    identity: '__IMAI_IDENTITY__',
    orgSlug: '__IMAI_ORG__',
    threadRouteRef: '__IMAI_THREAD__',
  });
  const lastTemplate = threadPanelLastDockedKey({
    identity: '__IMAI_IDENTITY__',
    orgSlug: '__IMAI_ORG__',
  });
  const shapeTemplate = threadTranscriptShapeKey({
    identity: '__IMAI_IDENTITY__',
    orgSlug: '__IMAI_ORG__',
    threadRouteRef: '__IMAI_THREAD__',
  });
  const config = JSON.stringify({
    template,
    shapeTemplate,
    shapeAttr: THREAD_SKELETON_SHAPE_ATTR,
    lastTemplate,
    identityKey: THREAD_PANEL_HINT_IDENTITY_KEY,
    attr: THREAD_PANEL_RESERVED_ATTR,
  });
  // The shape applies everywhere; the panel column only where it docks
  // (useArtifactDrawerLayout: touch-primary or narrow viewports use a drawer).
  return `(function(){try{var c=${config};if(!c.template)return;var m=location.pathname.match(/^\\/([^/]+)\\/threads\\/([^/?#]+)/);if(!m)return;var id=localStorage.getItem(c.identityKey);if(!id)return;var e=function(s){return encodeURIComponent(decodeURIComponent(s));};var fill=function(t){return t.replace('__IMAI_IDENTITY__',encodeURIComponent(id)).replace('__IMAI_ORG__',e(m[1])).replace('__IMAI_THREAD__',e(m[2]));};var root=document.documentElement;var shape=c.shapeTemplate?localStorage.getItem(fill(c.shapeTemplate)):null;if(shape)root.setAttribute(c.shapeAttr,shape);if(window.matchMedia('(max-width: 1023px)').matches)return;var touch=('ontouchstart' in window||navigator.maxTouchPoints>0)&&window.matchMedia('(pointer: coarse)').matches;if(touch)return;var own=localStorage.getItem(fill(c.template));var v=own!==null?own:(c.lastTemplate?localStorage.getItem(fill(c.lastTemplate)):null);if(v==='1')root.setAttribute(c.attr,'');}catch(e){}})();`;
}
